import { useExecutor } from '@/hooks/useExecutor'
import { declareComponent } from '@/registry'
import { useStore } from '@/stores/hooks'
import { Loading } from '../Loading'

export const Calendar = /*#__PURE__*/ declareComponent(
	'ui-calendar',
	'ui-calendar',
	() => import(/* webpackChunkName: 'ui-calendar' */ './Calendar'),
	Loading,
)

export function usePreloadCalendar(): (options?: {
	level?: number
}) => Promise<void> {
	const store = useStore()
	const executor = useExecutor()
	return async ({ level = 0 } = {}) => {
		await Calendar.preload({ level, store, executor })
	}
}
